<template>
  <footer>
    <div class="container h-100">
      <div class="row py-4">
        <div class="col-12 col-xs-10 col-md-12 col-xl-8 mx-auto">
          <div class="row">
            <div class="col-6 col-md-3 order-3 order-md-1">
              <p class="small fw-bold test mb-2">{{ isDutch ? 'Ontdek' : 'Explore' }}</p>
              <ul class="small list-unstyled opacity-75">
                <li>
                  <NuxtLink
                      class="inherit d-block"
                      role="button"
                      :title="isDutch ? 'Lees onze blog' : 'Read our blog'"
                      :to="{ name: isDutch ? 'nl-blog' : 'blog'}"
                  >
                    Blog
                  </NuxtLink>
                  <NuxtLink
                      class="inherit d-block"
                      role="button"
                      :title="isDutch ? 'Luchtvaartmaatschappijen' : 'Airlines'"
                      :to="{ name: isDutch ? 'nl-luchtvaartmaatschappijen' : 'airlines'}"
                  >
                    {{ isDutch ? 'Luchtvaartmaatschappijen' : 'Airlines' }}
                  </NuxtLink>
                  <NuxtLink
                      class="inherit d-block"
                      role="button"
                      title="Contact"
                      :to="{ name: 'contact' }"
                  >
                    Contact
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div class="col-6 col-md-3 order-1 order-md-2">
              <p class="small fw-bold test mb-2">
                {{ isDutch ? 'Luchthaven' : 'Airport' }}
              </p>
              <ul class="small list-unstyled opacity-75">
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'KLM vluchten vanaf Amsterdam' : 'KLM Flights from Amsterdam'"
                      :to="{ name: isDutch ? 'vluchten-vanaf' : 'flights-from', params: { name: 'amsterdam', iata: 'ams' }}"
                  >
                    {{ isDutch ? 'Vluchten vanaf Amsterdam' : 'Flights from Amsterdam' }}
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'Air France vluchten vanaf Parijs (CDG)' : 'Air France Flights from Paris (CDG)'"
                      :to="{ name: isDutch ? 'vluchten-vanaf' : 'flights-from', params: { name: (isDutch ? 'parijs' : 'paris'), iata: 'cdg' }}"
                  >
                    {{ isDutch ? 'Vluchten vanaf Parijs (CDG)' : 'Flights from Paris (CDG)' }}
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'Air France vluchten vanaf Parijs (ORY)' : 'Air France Flights from Paris (ORY)'"
                      :to="{ name: isDutch ? 'vluchten-vanaf' : 'flights-from', params: { name: (isDutch ? 'parijs' : 'paris'), iata: 'ory' }}"
                  >
                    {{ isDutch ? 'Vluchten vanaf Parijs (ORY)' : 'Flights from Paris (ORY)' }}
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'Air France vluchten vanaf Lyon' : 'Air France Flights from Lyon'"
                      :to="{ name: isDutch ? 'vluchten-vanaf' : 'flights-from', params: { name: 'lyon', iata: 'lys' }}"
                  >
                    {{ isDutch ? 'Vluchten vanaf Lyon' : 'Flights from Lyon' }}
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'Air France vluchten vanaf Nice' : 'Air France Flights from Nice'"
                      :to="{ name: isDutch ? 'vluchten-vanaf' : 'flights-from', params: { name: 'nice' , iata: 'nce' }}"
                  >
                    {{ isDutch ? 'Vluchten vanaf Nice' : 'Flights from Nice' }}
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div class="col-6 col-md-3 order-2 order-md-3">
              <p class="small fw-bold test mb-2">
                {{ isDutch ? 'Populaire vliegroutes' : 'Popular Flight Routes' }}
              </p>
              <ul class="small list-unstyled opacity-75">
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'KLM vluchten vanaf Amsterdam naar New York' : 'KLM Flights from Amsterdam to New York'"
                      :to="{ name: isDutch ? 'vluchten-tussen' : 'flights-between', params: { name: 'amsterdam', iata: 'ams', toname: 'newyork', toiata: 'jfk' }}"
                      >
                    {{ isDutch ? 'Amsterdam naar New York' : 'Amsterdam to New York' }}
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'KLM vluchten vanaf Amsterdam naar Barcelona' : 'KLM Flights from Amsterdam to Barcelona'"
                      :to="{ name: isDutch ? 'vluchten-tussen' : 'flights-between', params: { name: 'amsterdam', iata: 'ams', toname: 'barcelona', toiata: 'bcn' }}"
                  >
                    {{ isDutch ? 'Amsterdam naar Barcelona' : 'Amsterdam to Barcelona' }}
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'KLM Vluchten vanaf Amsterdam naar Londen' : 'KLM Flights from Amsterdam to London'"
                      :to="{ name: isDutch ? 'vluchten-tussen' : 'flights-between', params: { name: 'amsterdam', iata: 'ams', toname: isDutch ? 'londen' : 'london', toiata: 'lhr' }}"
                  >
                    {{ isDutch ? 'Amsterdam naar Londen' : 'Amsterdam to London' }}
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'KLM vluchten vanaf Amsterdam naar Stockholm' : 'KLM Flights from Amsterdam to Stockholm'"
                      :to="{ name: isDutch ? 'vluchten-tussen' : 'flights-between', params: { name: 'amsterdam', iata: 'ams', toname: isDutch ? 'stockholm' : 'stockholm', toiata: 'arn' }}"
                  >
                    {{ isDutch ? 'Amsterdam naar Stockholm' : 'Amsterdam to Stockholm' }}
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink
                      class="inherit"
                      role="button"
                      :title="isDutch ? 'KLM vluchten vanaf Amsterdam naar Kopenhagen' : 'KLM Flights from Amsterdam to Copenhagen'"
                      :to="{ name: isDutch ? 'vluchten-tussen' : 'flights-between', params: { name: 'amsterdam', iata: 'ams', toname: isDutch ? 'kopenhagen' : 'copenhagen', toiata: 'cph' }}"
                  >
                    {{ isDutch ? 'Amsterdam naar Kopenhagen' : 'Amsterdam to Copenhagen' }}
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div class="col-6 col-md-3 order-4 order-md-4">
              <div class="mb-3">
                <p class="small fw-bold test mb-2">Apps</p>
                <div class="d-flex">
                  <a title="Download in Google Play" href="https://play.google.com/store/apps/details?id=flights.rewards.twa" target="_blank" rel="me nofollow noopener">
                    <i class="fa-brands fa-google-play text-primary fs-3"></i>
                  </a>
                  <a title="Download in App Store" class="ms-3" href="https://apps.apple.com/app/apple-store/id1672941903?pt=952205&ct=Website&mt=8" target="_blank" rel="me nofollow noopener">
                    <i class="fa-brands fa-app-store text-primary fs-3"></i>
                  </a>
                  <a title="Download Firefox Browser Extension" class="ms-3" href="https://addons.mozilla.org/en-US/firefox/addon/reminder-for-flying-blue/" target="_blank" rel="me nofollow noopener">
                    <i class="fa-brands fa-firefox-browser text-primary fs-3"></i>
                  </a>
                  <a title="Download Chrome Browser Extension" class="ms-3" href="https://chromewebstore.google.com/detail/flying-blue-%E2%80%93-shop-earn-m/dkmpgahpjfoicikbpmhmcichhedeaofk" target="_blank" rel="me nofollow noopener">
                    <i class="fa-brands fa-chrome text-primary fs-3"></i>
                  </a>
                </div>
              </div>
              <div>
                <p class="small fw-bold test mb-2">Socials</p>
                <div class="d-flex">
                  <a title="Follow us on X (Twitter)" href="https://x.com/rewardsflights" target="_blank" rel="me nofollow noopener">
                    <i class="fa-brands fa-x-twitter text-primary fs-3"></i>
                  </a>
                  <a title="Follow us on Instagram" class="ms-3" href="https://www.instagram.com/rewards.flights/" target="_blank" rel="me nofollow noopener">
                    <i class="fa-brands fa-instagram text-primary fs-3"></i>
                  </a>
                  <a title="Follow us on Threads" class="ms-3" href="https://threads.net/@rewards.flights" target="_blank" rel="me nofollow noopener">
                    <i class="fa-brands fa-threads text-primary fs-3"></i>
                  </a>
                  <a title="Follow us on Bluesky" class="ms-3" href="https://bsky.app/profile/rewards.flights" target="_blank" rel="me nofollow noopener">
                    <i class="fa-brands fa-bluesky text-primary fs-3"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sub-footer py-1">
      <div class="container">
        <div class="row">
          <div class="col-12 col-xs-10 col-md-12 col-xl-8 mx-auto py-2 d-md-flex">
            <p class="extra-small opacity-75 mb-0 text-center me-auto">© 2025 – rewards.flights</p>
            <p class="extra-small opacity-75 mb-0 text-center">rewards.flights is not affiliated with, endorsed by, or linked to KLM, Air France, or Flying Blue.</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
const isDutch = inject('isDutch');
</script>